<template>
	<div>
		<v-text-field :label="label" v-model="value" outlined hide-details dense :placeholder="placeholder" @keyup.enter.native="emitMe()" v-on:blur="emitMe()"></v-text-field>
	</div>
</template>
 
<script>
    import {
        mdiMinus,
        mdiPlus,
	} from '@mdi/js';
	
    export default {
        name: 'inputtffloat',
        props: {
            count: {
                default: "0.00"
            },
            label: {
                default: ""
            },
            placeholder: {
                default: ""
            }, 
        },
        model: {
            prop: 'count',
            event: 'input'
        },
        data: () => ({ 
            value: "0.0"
        }),
        watch: {
            count: function(n) {
				this.value = n || "0.00"
				this.fixValue();
			} 
        },
        mounted() {
			this.value = this.count || "0.00"
			this.fixValue();
        },
        methods: {
            emitMe(){ 
				this.fixValue();
			},
			fixValue(){
				this.value = this.value.replace(/[^\d.-]/g, '')
				this.value = parseFloat(this.value).toFixed(2) || "0.00"
				this.$emit("input",this.value)
			}
        },
        computed: { }
    }
</script>